import clsx from 'clsx'
import React from 'react'

import { Text } from '@wartek-id/text'

import type { MouseEvent } from 'react'

import ArrowRightIcon from 'assets/icons/arrow-alt-right-o.svg'

interface TextMateriPageNavigationProps {
  currentIndex: number
  totalPage: number
  onPrevious: (event: MouseEvent) => void
  onNext: (event: MouseEvent) => void
}

const TextMateriPageNavigation = ({
  currentIndex,
  totalPage,
  onPrevious,
  onNext,
}: TextMateriPageNavigationProps) => {
  return (
    <div className="fixed left-0 bottom-0 flex items-center justify-between px-4 h-16 w-full max-w-xl m-auto right-0 bg-gray-5">
      <Text
        data-testid="prev-button"
        as="button"
        type="button"
        className={clsx(
          'flex items-center justify-center w-[44px] h-[44px] focus:outline-none rounded-lg',
          currentIndex === 0 ? 'bg-interactive-disabled' : 'bg-blue-50'
        )}
        onClick={onPrevious}
      >
        <ArrowRightIcon
          className="transform rotate-180"
          color="#fff"
          height="20"
          width="20"
        />
      </Text>
      <Text variant="body-bold">
        Halaman {currentIndex + 1} dari {totalPage}
      </Text>
      <Text
        data-testid="next-button"
        as="button"
        type="button"
        className={clsx(
          'flex items-center justify-center w-[44px] h-[44px] focus:outline-none rounded-lg',
          currentIndex + 1 === totalPage
            ? 'bg-interactive-disabled'
            : 'bg-blue-50 '
        )}
        onClick={onNext}
      >
        <ArrowRightIcon color="#fff" height="20" width="20" />
      </Text>
    </div>
  )
}

export default TextMateriPageNavigation
